import { Component, input, signal, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../atoms/icon/icon.component';

export interface FaqItem {
  question: string;
  answer: string;
}

@Component({
  selector: 'htx-faq-accordion',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './faq-accordion.component.html',
  styleUrl: './faq-accordion.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqAccordionComponent {
  items = input.required<FaqItem[]>();
  openIndex = signal<number>(-1);

  toggle(index: number): void {
    this.openIndex.set(this.openIndex() === index ? -1 : index);
  }
}
